import * as log from "loglevel";

import { REACT_APP_ENV } from "../configs";
import { ENVIRONMENT } from "../constants";

if (REACT_APP_ENV === ENVIRONMENT.DEV) {
  log.setLevel("info");
} else {
  log.setLevel("warn");
}

export default log;
